<app-viewer-header></app-viewer-header>
<div id="camera-viewer">
  @if (isSnapshotView) {
    <app-snapshot-viewer></app-snapshot-viewer>
  } @else {
    <app-camera-viewer></app-camera-viewer>
  }
</div>
<app-footer></app-footer>
